import Icon from './Icon'
import React, { useEffect, useState } from 'react'
import Trans from './Trans'
import { useRouter } from 'next/router'

const Pagination = React.memo(({ pagination, handleChangePage, currentPage }) => {
  const router = useRouter()

  const [isCanonical, setIsCanonical] = useState(false)

  useEffect(() => {
    handleSEOPagination(router.query)
  }, [router.query])

  function handleSEOPagination(query) {
    setIsCanonical(!(Object.keys(query).filter((key) => key !== 'p').length > 0))
  }

  function handleChangePageSEO(page) {
    if (isCanonical) return
    handleChangePage(page)
  }

  let before = []
  let after = []

  const isActive = (page) => {
    return currentPage === page ? 'pagination__item--active' : ''
  }

  const isDisabled = (rel) => {
    if (rel === 'prev' && currentPage === 1)
      return { status: true, class: 'pagination__nav--disabled' }
    else if (rel === 'next' && currentPage === pagination.num_pages)
      return { status: true, class: 'pagination__nav--disabled' }
    return { status: false, class: '' }
  }

  const checkSeparator = () => {
    if (pagination.num_pages > 4) {
      if (currentPage + 3 < pagination.num_pages) return true
      else if (currentPage - 3 >= 0 && currentPage + 3 !== pagination.num_pages) return true
    } else return false
  }

  // CASI:
  // currentPage + 3 < pagination.num_pages
  // currentPage + 3 === pagination.num_pages
  // currentPage - 3 > 1

  if (pagination.num_pages > 4) {
    if (currentPage + 3 < pagination.num_pages) {
      before = pagination.page_range.slice(currentPage - 1, currentPage + 2).map((page) => (
        <a
          className={`pagination__item ${isActive(page)}`}
          onClick={() => handleChangePageSEO(page)}
          key={page}
          href={isCanonical ? `${router.asPath.split('?')[0]}?p=${page}` : null}
        >
          {page}
        </a>
      ))

      after.push(
        <a
          className={`pagination__item`}
          onClick={() => handleChangePageSEO(pagination.num_pages)}
          key={pagination.num_pages}
          href={isCanonical ? `${router.asPath.split('?')[0]}?p=${pagination.num_pages}` : null}
        >
          {pagination.num_pages}
        </a>
      )
    } else if (currentPage + 3 === pagination.num_pages) {
      before = pagination.page_range.slice(currentPage - 1, currentPage + 3).map((page) => (
        <a
          className={`pagination__item ${isActive(page)}`}
          onClick={() => handleChangePageSEO(page)}
          key={page}
          href={isCanonical ? `${router.asPath.split('?')[0]}?p=${page}` : null}
        >
          {page}
        </a>
      ))
    } else if (currentPage - 3 >= 0) {
      before.push(
        <a
          className={`pagination__item`}
          onClick={() => handleChangePageSEO(1)}
          key={1}
          href={isCanonical ? `${router.asPath.split('?')[0]}?p=${1}` : null}
        >
          {1}
        </a>
      )

      after = pagination.page_range
        .slice(pagination.num_pages - 3, pagination.num_pages)
        .map((page) => (
          <a
            className={`pagination__item ${isActive(page)}`}
            onClick={() => handleChangePageSEO(page)}
            key={page}
            href={isCanonical ? `${router.asPath.split('?')[0]}?p=${page}` : null}
          >
            {page}
          </a>
        ))
    }
  } else if (pagination.num_pages) {
    before = pagination.page_range.map((page) => (
      <a
        className={`pagination__item ${isActive(page)}`}
        onClick={() => handleChangePageSEO(page)}
        key={page}
        href={isCanonical ? `${router.asPath.split('?')[0]}?p=${page}` : null}
      >
        {page}
      </a>
    ))
  }

  const handleChangePageRel = (page, rel) => {
    if (!isDisabled(rel).status) handleChangePage(page)
  }

  return (
    <div className="pagination effect-fadeup">
      <a
        className={`pagination__nav pagination__nav--prev ${isDisabled('prev').class}`}
        onClick={() => handleChangePageRel(currentPage - 1, 'prev')}
      >
        <Icon id="chevron-right" />
        <span>
          <Trans chiave="Back" />
        </span>
      </a>

      {before}

      {checkSeparator() ? (
        <span className="pagination__item pagination__item--separator"></span>
      ) : null}

      {after}

      <a
        className={`pagination__nav pagination__nav--next ${isDisabled('next').class}`}
        onClick={() => handleChangePageRel(currentPage + 1, 'next')}
      >
        <span>
          <Trans chiave="Next" />
        </span>
        <Icon id="chevron-right" />
      </a>
    </div>
  )
})

export default Pagination
